import { createFileRoute } from '@tanstack/react-router';
import { PagesListPage } from '@/features/analytics/pages/pages-list-page';

/** `/analytics/new`: the analytics overview with the new-dashboard dialog open. */
export const Route = createFileRoute('/_app/w/$workspaceId/analytics/new')({
    staticData: {
        crumbs: [{ label: 'shell.analytics', to: '/w/$workspaceId/analytics' }, { label: 'analytics.newDashboard' }],
    },
    component: function NewDashboardRoute() {
        const { workspaceScope } = Route.useRouteContext();
        return <PagesListPage scope={workspaceScope} create />;
    },
});
